import {
  Modal,
  Button,
  Box,
  Text,
  createStyles,
  Select,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import swal from "sweetalert";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { editPayer, getpayer } from "../../services/payer";
import { stateZipCodes } from "../../utils/zipCodes";
import { IconChevronDown } from "@tabler/icons-react";

const useStyles = createStyles(() => ({
  mainbox: {
    background: " #F5F5F5",
    padding: "13px 19px",
  },
  addbox: {
    padding: "15px 13px 54px 13px",
    borderRadius: "16px",
    border: "1px solid #E5E5EA",
    background: "#FCFCFC",
  },

  width50: {
    width: "50%",
  },

  mainbtn: {
    display: "flex",
    gap: "10px",
    justifyContent: "flex-end",
    marginTop: "46px",
    marginBottom: "78px",
  },

  formRow: {
    width: "100%",
    display: "flex",
    gap: "17px",
    marginBottom: "20px",
    marginTop: "20px",
    "@media (max-width:1300px)": {
      flexDirection: "column",
      gap: "10px",
    },

    mt19: {
      marginTop: "19px",
    },

    boxtype: {
      display: "flex",
      flexDirection: "row",
    },

    flexend: {
      display: "flex",
      justifyContent: "flex-end",
    },
  },
  selectnumber: {
    width: "140px",
    padding: "5px 15px",
    borderRadius: "5px",
    backgroundColor: bgColor,
    // width: "50%",
    "& input": {
      backgroundColor: "transparent",
      border: "none",
      paddingInline: 0,
    },
  },

  line: {
    width: "2px",
    height: "42.011px",
    background: "#525252",
  },

  dflex: {
    display: "flex",
    justifyContent: "space-between",
  },

  boxnumber: {
    display: "flex",
    flexDirection: "row",
    width: "min-content",
    // justifyContent:'flex-end'
  },
}));

const bgColor = "#FFFFFF";
const CustomTextInput = ({ ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "5px 15px",
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      backgroundColor: bgColor,
      "& input": {
        backgroundColor: "transparent",
        border: "none",
        paddingInline: 0,
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <TextInput {...rest} />
    </div>
  );
};

const CustomSelectBox = ({ ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "5px 11px",

      backgroundColor: bgColor,
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      "& input": {
        border: "none",
        paddingInline: 0,
        backgroundColor: "transparent",
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <Select
        {...rest}
        rightSection={<IconChevronDown color={"#94A3B8"} size={20} />}
        rightSectionWidth={25}
        styles={{ rightSection: { pointerEvents: "none" } }}
      />
    </div>
  );
};

const EditPayer = ({
  EditPayerModalOpen,
  setEditPayerModalOpen,
  item,
  isPreview,
}) => {
  // console.log('item',item);

  const { classes } = useStyles();
  const { profile } = useSelector((state) => state?.profile);

  const form = useForm({
    initialValues: {
      payerName: "",
      payerId: "",
      payerEntity: "",
      transaction: "",
      payerAddress1: "",
      payerAddress2: "",
      payerCity: "",
      payerState: "",
      payerZip: "",
    },
  });

  useEffect(() => {
    if (item) {
      // console.log('item',item)
      form.setValues({
        payerName: item?.payerName || "",
        payerId: item?.payerId || "",
        payerEntity: item?.payerEntity || "",
        transaction: item?.transaction || "",
        payerAddress1: item?.payerAddress1 || "",
        payerAddress2: item?.payerAddress2 || "",
        payerCity: item?.payerCity || "",
        payerState: item?.payerState || "",
        payerZip: String(item?.payerZip) || "",
      });
    }
  }, [item]);

  const onSave = async () => {
    let values = form.values;
    let missingFields = [];
    const optionalFields = [
      "payerAddress1",
      "payerAddress2",
      "payerEntity",
      "payerCity",
      "payerState",
      "payerZip",
    ];
    Object.entries(values)
      .filter(([key, _]) => !optionalFields.includes(key))
      .forEach(([key, value]) => !value && missingFields.push(key));

    if (missingFields.length > 0) {
      await swal({
        title: "Please fill out the following fields",
        text: missingFields.join(", "),
        icon: "warning",
        dangerMode: true,
      });
      return;
    }

    const selectedState = values.payerState?.trim();
    const enteredZipCode = values.payerZip?.trim();

    if (selectedState && enteredZipCode) {
      const stateZipCodeEntries = stateZipCodes.filter(
        (entry) => entry.ste_name === selectedState
      );

      const isZipValid = stateZipCodeEntries.some(
        (entry) => entry.zip_code === enteredZipCode
      );

      if (!isZipValid) {
        await swal({
          title: "Invalid Zip Code",
          text: `The zip code you entered is not valid for ${selectedState}. Please enter a valid zip code.`,
          icon: "warning",
          dangerMode: true,
        });
        return;
      }
    }

    let payload = {
      values,
          createdBy: profile.user.id,
        admin: profile?.user?.admin ?? profile?.user?.id,
      id: item.id,
    };

    const res = await editPayer(payload);

    if (res.status === 200) {
      let payload={
        page:1
      }
      getpayer(payload);
      handleClose();
      swal({
        title: `Payer updated successfully`,
        text: "Payer update successful",
        dangerMode: false,
      });
    }
    // setEditPayerModalOpen(false);
    // handleClose()
  };

  const handleClose = () => {
    // setIsPreview(false);
    setEditPayerModalOpen(false);
  };

  return (
    <Modal
      opened={EditPayerModalOpen}
      onClose={handleClose}
      title="Edit Payer"
      size={700}
      radius={"md"}
      zIndex={1000}
      centered
      styles={{
        title: {
          color: "#000",
          fontSize: "24px",
          fontWeight: "700",
        },
      }}
    >
      <Box className={classes.mainbox}>
        <Text
          style={{ marginBottom: "9px", marginTop: "16px" }}
          ff={"Inter"}
          fz={16}
          fw={600}
          color="#171717"
        >
          Payer Information
        </Text>
        <Box className={classes.addbox}>
          <form onSubmit={form.onSubmit((values) => onSave(values))}>
            <div className={classes.formRow}>
              <Box style={{ width: "100%" }}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Payer Name
                </Text>

                {/* medication name */}
                <CustomTextInput
                  id="payername"
                  // label={"Facility Name"}
                  size="sm"
                  disabled={isPreview}
                  // placeholder={"Enter Medication Name"}
                  // {...form.getInputProps("medicationName")}
                  withAsterisk
                  {...form.getInputProps("payerName")}
                  // disabled={true}
                  // value={selectedPayer?.payername}
                />
              </Box>
            </div>

            <div style={{ marginTop: "19px" }} className={classes.formRow}>
              <Box className={classes.width50}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  State
                </Text>

                <CustomSelectBox
                  id="state"
                  size="sm"
                  withAsterisk
                  disabled={isPreview}
                  data={Array.from(
                    new Set(stateZipCodes?.map((obj) => obj.ste_name))
                  )
                    ?.sort()
                    ?.map((ste_name) => ({
                      value: ste_name,
                      label: ste_name,
                    }))}
                  {...form.getInputProps("payerState")}
                  searchable
                />
              </Box>

              <Box className={classes.width50}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  City
                </Text>

                {/* medication name */}
                <CustomTextInput
                  id="medication-name"
                  // label={"Facility Name"}
                  disabled={isPreview}
                  size="sm"
                  // placeholder={"Enter Medication Name"}
                  // {...form.getInputProps("medicationName")}
                  withAsterisk
                  {...form.getInputProps("payerCity")}
                  // disabled={isPreview}
                />
              </Box>
            </div>

            <div className={classes.formRow}>
              <Box className={classes.width50}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Payer ID
                </Text>

                <CustomTextInput
                  id="medication-name"
                  disabled={isPreview}
                  // label={"Taxonomy/Speciality"}
                  size="sm"
                  // type="number"
                  // placeholder={"Enter Medication Name"}
                  // {...form.getInputProps("medicationName")}
                  withAsterisk
                  {...form.getInputProps("payerId")}
                  // disabled={true}
                  // value={selectedPayer?.payerid}
                />
              </Box>

              <Box className={classes.width50}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Zip Code
                </Text>

                <CustomTextInput
                  id="zip-code"
                  type="number"
                  disabled={isPreview}
                  // label={"Taxonomy/Speciality"}
                  size="sm"
                  // type="number"
                  // placeholder={"Enter Medication Name"}
                  // {...form.getInputProps("medicationName")}
                  withAsterisk
                  {...form.getInputProps("payerZip")}
                  // disabled={true}
                  // value={selectedPayer?.payerid}
                />
              </Box>
            </div>

            <div className={classes.formRow}>
              <Box className={classes.width50}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Payer Entity
                </Text>

                <CustomSelectBox
                  id="billing-type"
                  disabled={isPreview}
                  placeholder={"Select Payer"}
                  withAsterisk
                  data={[
                    { value: "Medicare", label: "Medicare" },
                    { value: "Medicaid", label: "Medicaid" },
                    { value: "Tricare", label: "Tricare" },
                    { value: "ChampVA", label: "ChampVA" },
                    {
                      value: "Group Health Insurance",
                      label: "Group Health Insurance",
                    },
                    { value: "FEKA BLK LUNG", label: "FEKA BLK LUNG" },
                    { value: "Other", label: "Other" },
                  ]}
                  {...form.getInputProps("payerEntity")}
                />
              </Box>

              <Box className={classes.width50}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Transaction
                </Text>
                <CustomTextInput
                  id="transaction"
                  size="sm"
                  disabled={isPreview}
                  withAsterisk
                  {...form.getInputProps("transaction")}
                  // disabled={true}
                  // value={selectedPayer?.transaction}
                />
              </Box>
            </div>

            <Box>
              <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                Address 1
              </Text>

              {/* medication name */}
              <CustomTextInput
                id="medication-name"
                // label={"Facility Name"}
                disabled={isPreview}
                size="sm"
                // placeholder={"Enter Medication Name"}
                // {...form.getInputProps("medicationName")}
                withAsterisk
                {...form.getInputProps("payerAddress1")}
                // disabled={isPreview}
              />
            </Box>

            <Box mt={10}>
              <Text
                {...form.getInputProps("type")}
                ff={"Inter"}
                fz={14}
                fw={500}
                color="#344054"
                disabled={isPreview}
              >
                Address 2
              </Text>

              {/* medication name */}
              <CustomTextInput
                id="medication-name"
                // label={"Facility Name"}
                size="sm"
                disabled={isPreview}
                // placeholder={"Enter Medication Name"}
                // {...form.getInputProps("medicationName")}
                {...form.getInputProps("payerAddress2")}
                // disabled={isPreview}
              />
            </Box>
          </form>
        </Box>

        <Box className={classes.mainbtn}>
          <Button
            onClick={handleClose}
            variant="fixed"
            c="#1D2939"
            radius="md"
            size="md"
            bg={"#F9FAFB"}
            style={{
              borderRadius: "8px",
              border: " 1px solid  #D0D5DD",
            }}
          >
            Cancel
          </Button>
          <Button
            // type="submit"
            onClick={onSave}
            disabled={isPreview}
            variant="filled"
            c="#000"
            radius="md"
            size="md"
            color="yellow"
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditPayer;
